/** Sales Signals: the sales the ERP never records - items out of stock while
 *  they sell, best sellers about to run out, regular customers who stopped,
 *  stock that does not move (backend/chainlit/sales_engine.py). The page
 *  itself is EnginePage. */
import EnginePage from '@/components/engine/EnginePage';
import { SALES_API } from '@/components/engine/api';

export default function SalesEngine() {
  return (
    <EnginePage
      api={SALES_API}
      eyebrow="Sales Signals"
      fallbackTitle="Sales Signals: the sales you are losing"
    />
  );
}
